"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CAREAPP_ASSETS = 'careapp-assets';
exports.ADMIN = 'admin';
exports.ADMINISTRATION = 'administration';
exports.CAREAPP = 'careapp';
exports.CONVERSATIONS = 'conversations';
exports.MEMBER_PROFILE_IMAGES = 'member-profile-images';
exports.TENANT_RESERVED_IDS = [exports.CAREAPP_ASSETS, exports.ADMIN, exports.ADMINISTRATION, exports.CAREAPP, exports.CONVERSATIONS, exports.MEMBER_PROFILE_IMAGES];
